module.exports = __webpack_public_path__ + "img/logo.146e34df.png";